import { render, staticRenderFns } from "./TermsAndPrivacy.vue?vue&type=template&id=4f4f1112&"
import script from "./TermsAndPrivacy.vue?vue&type=script&lang=js&"
export * from "./TermsAndPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndPrivacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports